











































































import {Component, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import MemberApi from '@/apis/MemberApi';
import MemberBankAccountResponseModel from '@/models/member/MemberBankAccountResponseModel';
import MemberConfirmBankAccountRequestModel from '@/models/member/MemberConfirmBankAccountRequestModel';

@Component({
        name: 'MemberBankAccounts',
    },
)
export default class MemberBankAccounts extends ViewBase {
    public bankAccounts: MemberBankAccountResponseModel[] = [];
    public invitations: MemberBankAccountResponseModel[] = [];
    public invitationBankAccountId: number = 0;
    public invitationAction: string = '';
    public inviteError: boolean = false;
    public errorBankAccountId: number = 0;

    public get showBankAccounts(): boolean {
        if ( !this.initializing && !this.initializationError ) {
            return true;
        }

        return false;
    }

    public get totalBalance(): number {
        const sum = this.bankAccounts.reduce((a: number, b: MemberBankAccountResponseModel) => {
            return a + b.balance;
        }, 0);

        return sum;
    }

    public inviteButtonLoading(bankAccountId: number, action: string): boolean {
        if ( this.invitationBankAccountId === bankAccountId && this.invitationAction === action ) {
            return true;
        }

        return false;
    }

    public inviteButtonDisabled(bankAccountId: number, action: string): boolean {

        if ( this.invitationBankAccountId === bankAccountId ) {
            if ( this.invitationAction !== action ) {
                return true;
            }
        }

        return false;
    }

    public showInviteError(bankAccountId: number): boolean {
        if ( this.errorBankAccountId === bankAccountId && this.inviteError === true ) {
            return true;
        }

        return false;
    }

    public async acceptAsync(bankAccountId: number, index: number) {
        try {
            this.invitationBankAccountId = bankAccountId;
            this.errorBankAccountId = bankAccountId;
            this.invitationAction = 'accept';
            this.inviteError = false;

            const request = new MemberConfirmBankAccountRequestModel();
            request.bankAccountId = bankAccountId;
            request.confirmed = true;

            const api = new MemberApi();
            const response = await api.confirmBankAccountMembershipAsync(this.$store.state.member.jwt, request);

            const bankAccount = this.invitations[index];
            // add bank to bank accounts list
            this.bankAccounts.push(bankAccount);
            // remove bank from invitations list
            this.invitations.splice(index, 1);

            this.errorBankAccountId = 0;
        }
        catch ( err ) {
            this.inviteError = true;
        }
        finally {
            this.invitationBankAccountId = 0;
            this.invitationAction = '';
        }
    }

    public async declineAsync(bankAccountId: number, index: number) {
        try {
            this.invitationBankAccountId = bankAccountId;
            this.errorBankAccountId = bankAccountId;
            this.invitationAction = 'decline';
            this.inviteError = false;

            const request = new MemberConfirmBankAccountRequestModel();
            request.bankAccountId = bankAccountId;
            request.confirmed = false;

            const api = new MemberApi();
            const response = await api.confirmBankAccountMembershipAsync(this.$store.state.member.jwt, request);

            // remove bank from invitations list
            this.invitations.splice(index, 1);

            this.errorBankAccountId = 0;
        }
        catch ( err ) {
            this.inviteError = true;
        }
        finally {
            this.invitationBankAccountId = 0;
            this.invitationAction = '';
        }
    }

    public async created() {

        try {
            this.resetInitializationValues();

            const api = new MemberApi();
            const bankAccounts = await api.getBankAccountsAsync(this.$store.state.member.jwt);

            this.bankAccounts = bankAccounts.filter((x: MemberBankAccountResponseModel) => x.confirmed === true);
            this.invitations = bankAccounts.filter((x: MemberBankAccountResponseModel) => x.confirmed === false);
        }
        catch ( err ) {
            await this.handleInitializationErrorAsync(err);
        }
        finally {
            this.initializing = false;
        }
    }

}
